import { useContext, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import { AppContext } from '../../../context/appContext';
import { PostApiContext } from '../../../context/apiCalls/postApiCalls';
import { GetApiContext } from '../../../context/apiCalls/getApiCalls';
import { toast } from 'react-toastify';

export default function EditProspect({ refreshProspectsList }) {
    const appContext = useContext(AppContext);
    const postApiCalls = useContext(PostApiContext);
    const getApiCalls = useContext(GetApiContext);
    const { id } = useParams();

    const callRef = useRef();
    const meetingRef = useRef();
    const dunningRef = useRef();
    const commentRef = useRef();
    const [prospect, setProspect] = useState([]);
    const idProspect = appContext.idprospect;

    useEffect(() => {
        getApiCalls.getProspect(id, idProspect)
            .then(response => {
                setProspect(response?.prospecting || {});
            });
    }, [appContext.idprospect, id, idProspect, getApiCalls]);

    const handleProspectSubmit = async (e) => {
        e.preventDefault();
        const values = {
            idContact: id,
            idProspect: idProspect,
            call: callRef?.current?.value,
            meeting: meetingRef?.current?.value,
            dunning: dunningRef?.current?.value,
            comment: commentRef?.current?.value,
        };

        try {
            const response = await postApiCalls.postProspect(values);
            if (response?.status === "success") {
                appContext.setShowEditProspectPopup(false);
                appContext.setReload(true);
                appContext.setBlur(false);
                toast.success("La prospection a bien été modifiée");
            } else {
                toast.error("Une erreur est survenue lors de la modification de la prospection");
            }
            if (refreshProspectsList) refreshProspectsList();
        } catch (error) {
            toast.error("Une erreur est survenue lors de la modification de la prospection");
            console.log(error);
        }
    };

    const closePop = () => {
        appContext.setShowEditProspectPopup(false);
        appContext.setBlur(false);
    };

    return (
        <div className='tablePop'>
            <h3 className='titlePop'>Editer une prospection</h3>
            <form className='formPop prospect-form-responsive' onSubmit={handleProspectSubmit} action="submit">
                <div className='borderForm'>
                    <div className='prospect-form-row'>
                        <label>Appel
                            <input className='pop-up-input' type="text" ref={callRef} defaultValue={prospect?.call} placeholder="Appel" />
                        </label>
                        <label>Rendez-vous
                            <input className='pop-up-input' type="text" ref={meetingRef} defaultValue={prospect?.meeting} placeholder="Rendez-vous" />
                        </label>
                        <label>Relance
                            <input className='pop-up-input' type="text" ref={dunningRef} defaultValue={prospect?.dunning} placeholder="Relance" />
                        </label>
                        <label>Commentaire
                            <input className='pop-up-input' type="text" ref={commentRef} defaultValue={prospect?.comment} placeholder="Commentaire" />
                        </label>
                    </div>
                </div>
                <div className='pop-up-validation'>
                    <button className='pop-up-valid' type='submit'>Confirmer</button>
                    <p className='pop-up-cancel' onClick={closePop}>Annuler</p>
                </div>
            </form>
        </div>
    );
}